export const ERROR = Symbol('error');
export const LOADING = Symbol('loading');
export const getModelError = (model) => (model instanceof Error ? model : model?.[ERROR] ?? model?.error);
export const isModelLoading = (model) => model === LOADING || !!(model?.[LOADING] ?? model?.loading);
